#
require('backbone').$ = $
$ require('../apps/home/client/index.coffee').init
